import React from 'react';
import { LFC } from '../../../Legacy';
import { JiraProjectData } from '../../../api/endpoints/jira';
import { usePrompt } from '../../../ui';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { CreateJiraIssueSource, CreateMultiSingleJiraIssueView } from './CreateMultiJiraIssueView';
import { CreateSingleJiraIssueView } from './CreateSingleJiraIssueView';

export type CreateJiraIssuesPopupArgs = {
    jiraProject: JiraProjectData,
    sources: CreateJiraIssueSource[],
};

export const createJiraIssuesPopup = (args: CreateJiraIssuesPopupArgs) => ({ ui: CreateJiraIssuesPopup, args });

export const CreateJiraIssuesPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const { jiraProject, sources } = args as CreateJiraIssuesPopupArgs;

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    return <Popup ref={promptRef} p="1" h="70%">
        <Popup.Title>
            {sources.length === 1 && 'Create Jira Issue'}
            {sources.length > 1 && `Create Jira Issues (${sources.length})`}
        </Popup.Title>
        <Popup.Content>
            <Flexer height=".5" />
            {sources.length === 1 && (
                <CreateSingleJiraIssueView
                    jiraProject={jiraProject}
                    source={sources?.[0] ?? {}}
                    onComplete={action}
                />
            )}
            {sources.length > 1 && (
                <CreateMultiSingleJiraIssueView
                    jiraProject={jiraProject}
                    sources={sources}
                    onComplete={action}
                />
            )}
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
